<template>
  <div class="mt-6">
    <div v-if="mfaLoginType">
      <ion-text class="text-md font-bold ion-text-brand">
        Current MFA Method
      </ion-text>
      <ion-text class="text-sm ion-text-brand mt-3 mb-8 block">
        <span
          >Your multi-factor authentication (MFA) method is currently set to
          using
          <strong
            class="ion-text-purple-3"
            :class="mfaLoginType == 'sms' ? 'uppercase' : 'capitalize'"
            >{{ mfaLoginType }}</strong
          >. To select other options, please disable it first.</span
        >
      </ion-text>
    </div>
    <div v-else>
      <ion-text class="text-md font-bold ion-text-brand">
        Select Authentication Method
      </ion-text>
      <ion-text class="text-sm ion-text-brand mt-3 mb-8 block">
        <span
          >Please select the multi-factor authentication (MFA) method you want
          to pair with your account.</span
        >
      </ion-text>
    </div>

    <ion-list class="bg-clear">
      <ion-radio-group
        @ionChange="handleChange($event)"
        :value="mfaOptionSelected"
      >
        <div v-for="mfaOption in mfaOptions" :key="mfaOption.type">
          <div
            class="border rounded-lg mt-4"
            :class="mfaOptionSelected == mfaOption.type ? '' : 'opacity-60'"
          >
            <ion-item class="default pr-3 py-2" lines="none">
              <ion-radio
                mode="md"
                :value="mfaOption.type"
                :disabled="
                  mfaSaving || (mfaLoginType && mfaLoginType !== mfaOption.type)
                "
              >
                <div class="flex item-top">
                  <ion-icon
                    :src="`/assets/security/${mfaOption.iconActive}.svg`"
                    class="ml-4 mr-2 mt-1 w-[16px]"
                    v-if="mfaOptionSelected == mfaOption.type"
                  ></ion-icon>
                  <ion-icon
                    :src="`/assets/security/${mfaOption.icon}.svg`"
                    class="ml-4 mr-2 mt-1 w-[16px]"
                    v-else
                  ></ion-icon>
                  <span class="ion-text-brand font-bold">{{
                    mfaOption.label
                  }}</span>
                </div>
              </ion-radio>
            </ion-item>
            <span
              class="block text-[12px] opacity-70 border-t rounded-b-lg -mt-1 pl-4 py-1 ion-text-brand bg-grey-2"
              v-html="mfaOption.note"
              v-if="mfaOptionSelected == mfaOption.type"
            ></span>
          </div>
        </div>
      </ion-radio-group>
    </ion-list>
    <div
      v-if="mfaUpdatedMsg"
      class="text-xs my-2 text-center ion-text-green fadein-500"
      v-html="mfaUpdatedMsg"
    ></div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
const customerStore = useCustomerStore();
const { mfaOptionSelected, mfaSaving, mfaLoginType, mfaUpdatedMsg } =
  storeToRefs(customerStore);
const { setMfaOptionSelected } = customerStore;
const active = computed(() => mfaOptionSelected.value == mfaLoginType.value);
const activeMsg = ref(
  "This is your current multi-factor authentication (MFA) method. To disable it, click the button below."
);
const defaultMsg = ref("We will send you a 6-digit verification code to your ");
const mfaOptions = computed(() => [
  {
    type: "sms",
    label: "SMS",
    note: active.value ? activeMsg.value : defaultMsg.value + "phone.",
    icon: "security-icon-sms",
    iconActive: "security-icon-sms-active",
  },
  {
    type: "email",
    label: "Email",
    note: active.value ? activeMsg.value : defaultMsg.value + "email.",
    icon: "security-icon-email",
    iconActive: "security-icon-email-active",
  },
  // more options later...
]);

const handleChange = (e) => {
  setMfaOptionSelected(e.target.value);
};

onMounted(() => {
  setMfaOptionSelected(mfaLoginType.value);
});
</script>
